<template>
  <div class="table-wrap mwow-table">
    <div class="th">
      <div class="td">订单号</div>
      <div class="td">内容价格</div>
      <div class="td">购买课时</div>
      <div class="td">赠送课时</div>
      <div class="td">实收金额</div>
      <div class="td">耗课数</div>
      <div class="td">剩余金额</div>
      <div class="td">可转课时</div>
      <div class="td">转课课时</div>
      <div class="td">转课金额</div>
      <div class="td">
        手续费<el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="240"
        >
          <p>门店根据规定在退/转课时收取额外费用，且手续费不可超过退课金额。</p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin-left: 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </div>
    </div>
    <div class="item">
      <div class="title">
        <p class="text">【课程】- {{ itemDetail.product_name }}</p>
        <p class="tips mwow-yellow" v-if="itemDetail.package_type === 2">
          时间课包只能一次性转成普通课包
        </p>
      </div>
      <div class="tr">
        <div class="td">{{ itemDetail.order_no }}</div>
        <div class="td">{{ itemDetail.spec_name }}</div>
        <div class="td">
          {{ itemDetail.quantity }}
        </div>
        <div class="td">
          {{ itemDetail.give_product_quantity }}
        </div>
        <div class="td">￥{{ itemDetail.receivable_amount }}</div>
        <div class="td">{{ itemDetail.consume_number }}</div>
        <div class="td">￥{{ itemDetail.usable_amount }}</div>
        <div class="td">
          {{ itemDetail.usable_number }}
        </div>
        <div class="td">
          <el-input
            v-model="refundNumber"
            type="number"
            placeholder="请输入"
            @change="handleRefundNumberChange"
            style="width: 80%"
            class="red"
            :disabled="itemDetail.package_type === 2"
          ></el-input>
        </div>
        <div class="td">
          <span class="mwow-red" style="font-weight: 400"
            >￥{{ refundAmount / 100 }}</span
          >
        </div>
        <div class="td">
          <el-input
            v-model="handlingFee"
            type="number"
            placeholder="请输入"
            style="width: 80%"
            class="red"
            @change="handleHandlingFeeChange"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { expendItemDetailApi } from "@/api/order";
import { solveLargeNumber } from "@/utils/common";
import eventBus from "@/utils/bus";
export default {
  props: ["originData"],
  data() {
    return {
      itemDetail: {
        // 转课订单数据
        unit_price: 0,
      },
      refundNumber: 0, // 转课课时
      handlingFee: 0, // 手续费
      refundResult: 0, // 应退金额
    };
  },
  computed: {
    refundAmount() {
      // 转课金额
      if (
        Number(this.itemDetail.unit_price) * Number(this.refundNumber) >
        Number(this.itemDetail.usable_amount)
      ) {
        return solveLargeNumber(this.itemDetail.usable_amount);
      } else {
        return Math.ceil(
          (solveLargeNumber(this.itemDetail.unit_price) *
            solveLargeNumber(this.refundNumber)) /
            100
        );
      }
    },
  },
  created() {
    const iid = Number(this.$route.query.iid);
    const sid = Number(this.$route.query.sid);
    if (iid && sid) {
      expendItemDetailApi({
        item_ids: [iid],
        student_id: sid,
      }).then((res) => {
        const data = res.data.list[0];
        this.itemDetail = {
          item_id: data.item_id,
          course_id: data.product_id,
          product_name: data.product_name,
          order_no: data.order_no,
          spec_name: data.spec_name,
          quantity: data.quantity,
          give_product_quantity: data.give_product_quantity,
          receivable_amount: data.receivable_amount,
          consume_number: data.item_course.consume_number,
          usable_amount: data.item_course.usable_amount,
          usable_number: data.item_course.usable_number,
          unit_price: data.unit_price,
          package_type: data.course.package_type,
        };
        this.refundNumber = this.itemDetail.usable_number;
        this.refundResult = this.itemDetail.usable_number;
        this.handleSum();
        this.handleEmit();
        this.$emit("change", data);
        eventBus.$emit(
          "order-transfer-output-com-get-data",
          data.course.package_type
        );
      });
    }
  },
  methods: {
    handleRefundNumberChange(v) {
      const n = Number(Number(v).toFixed(2));
      if (n < 0) {
        this.refundNumber = 0;
      } else if (n > Number(this.itemDetail.usable_number)) {
        this.$message({
          type: "warning",
          message: "转课课时不可大于可转课时",
        });
        this.refundNumber = 0;
        return false;
      } else {
        this.refundNumber = n;
      }
      this.handlingFee = 0;
      this.handleSum();
    },
    handleHandlingFeeChange(v) {
      const n = Number(Number(v).toFixed(2));
      if (n < 0) {
        this.handlingFee = 0;
      } else if (n > this.refundAmount / 100) {
        this.$message({
          type: "warning",
          message: "手续费不可大于转课金额",
        });
        this.handlingFee = 0;
        return false;
      } else {
        this.handlingFee = n;
      }
      this.handleSum();
    },
    handleSum() {
      const number = solveLargeNumber(this.refundNumber);
      const unit = solveLargeNumber(this.itemDetail.unit_price);
      const fee = solveLargeNumber(this.handlingFee);
      const usable = solveLargeNumber(this.itemDetail.usable_amount);
      if (
        Number(this.itemDetail.unit_price) * Number(this.refundNumber) >
        Number(this.itemDetail.usable_amount)
      ) {
        this.refundResult = (usable - fee) / 100;
      } else {
        this.refundResult = Math.ceil((number * unit - fee * 100) / 100) / 100;
      }
      this.handleEmit();
    },
    handleEmit() {
      this.$emit("update:originData", {
        shouldRefund: this.refundResult,
        refundNumber: this.refundNumber,
        handlingFee: this.handlingFee,
        refundAmount: this.refundAmount,
        ...this.itemDetail,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-wrap {
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #5c5d5e;
    padding: 12px;
  }
  .th {
    background-color: #f2f6fa;
    font-size: 12px;
    color: #5c5d5e;
    margin-bottom: 14px;
    display: flex;
    line-height: 42px;
    align-items: center;
    font-weight: bold;
    padding-left: 38px;
    .td {
      flex: 1;
      &:first-child {
        flex: 2;
      }
    }
  }
  .item {
    border: 1px solid #e1e5e9;
    margin-bottom: 14px;
    .title {
      padding: 0 31px;
      background: #f2f6fa;
      display: flex;
      align-items: center;
      .text {
        line-height: 42px;
        font-size: 14px;
        color: #5c5d5e;
        font-weight: bold;
      }
      .tips {
        font-size: 12px;
        margin-left: 24px;
      }
    }
    .tr {
      color: #5c5d5e;
      font-size: 12px;
      display: flex;
      line-height: 42px;
      font-weight: bold;
      align-items: center;
      padding-left: 38px;
      /deep/.td {
        flex: 1;
        &:first-child {
          flex: 2;
        }
        &.red {
          .el-input__inner {
            color: #f56c6c !important;
          }
        }
      }
    }
  }
}
</style>
